<template>
    <div class="main-menu">
        <!-- <el-col :span="12"> -->
        <!--    <p class="unfold" @click='nav'><i class="iconfont icon-hengpai" v-if="isCollapse"></i><i class="iconfont icon-shuxian" v-else></i></p>-->
            <el-menu background-color="#304156" text-color="rgb(191, 203, 217)" :default-active="activeIndex" router unique-opened class="el-menu-vertical-demo" :collapse="false" @select="handleSelect">
                <!-- <router-link to="/index"> -->
                    <el-menu-item index="/homepage" v-if="test('首页')">
                        <i class="iconfont icon-yemian-copy-copy"></i>
                        <span slot="title">首页</span>
                    </el-menu-item>
                <!-- </router-link> -->
                <!-- <router-link to="/bbquery"> -->
                    <el-menu-item index="/bbquery" v-if="test('报备查询')">
                        <i class="iconfont icon-chaxun"></i>
                        <span slot="title">报备查询</span>
                    </el-menu-item>
                <!-- </router-link> -->
                <el-submenu index="5" v-if="statistics">
                    <template slot="title">
                    <i class="iconfont icon-tongji"></i>
                    <span>统计查询</span>
                    </template>
                        <el-menu-item-group>
                            <el-menu-item index="/bbei" v-if="test('报备统计')">报备统计</el-menu-item>
                            <el-menu-item index="/byan" v-if="test('办宴统计')">办宴统计</el-menu-item>
                            <el-menu-item index="/xchu" v-if="test('乡厨统计')">乡厨统计</el-menu-item>
                            <el-menu-item index="/gli" v-if="test('管理员统计')">管理员统计</el-menu-item>
                            <el-menu-item index="/week" v-if="test('周报表')">周报表</el-menu-item>
                            <el-menu-item index="/day" v-if="test('日报表')">日报表</el-menu-item>
                        </el-menu-item-group>
                </el-submenu>
                <el-submenu index="7" v-if="role">
                    <template slot="title">
                    <i class="iconfont icon-jiaose"></i>
                    <span>人员管理</span>
                    </template>
                        <el-menu-item-group>
                            <el-menu-item index="/country" v-if="test('乡厨管理')">乡厨管理</el-menu-item>
                            <el-menu-item index="/sabrole" v-if="test('食安办管理')">食安办管理</el-menu-item>
                            <el-menu-item index="/assist" v-if="test('协管员管理')">协管员管理</el-menu-item>
                            <el-menu-item index="/help" v-if="test('帮厨管理')">帮厨管理</el-menu-item>
                        </el-menu-item-group>
                </el-submenu>
                <el-submenu index="6" v-if="inter">
                    <template slot="title">
                    <i class="iconfont icon-wangzhan"></i>
                    <span>网站管理</span>
                    </template>
                        <el-menu-item-group>
                            <el-menu-item index="/agreement" v-if="test('基础信息')">基础信息</el-menu-item>
                            <el-menu-item index="/agreengl" v-if="test('协议管理')">协议管理</el-menu-item>
                        </el-menu-item-group>
                </el-submenu>
                <el-submenu index="8" v-if="jurisdiction">
                    <template slot="title">
                    <i class="iconfont icon-ic_opt_feature"></i>
                    <span>权限管理</span>
                    </template>
                        <el-menu-item-group>
                            <el-menu-item index="/rolelist" v-if="test('管理员列表')">管理员列表</el-menu-item>
                            <el-menu-item index="/jurisdiction" v-if="test('权限管理')">角色组</el-menu-item>
                            <el-menu-item index="/message" v-if="test('短信管理')">短信管理</el-menu-item>
                            <el-menu-item index="/reportconfig" v-if="test('报备字段管理')">报备字段管理</el-menu-item>
                        </el-menu-item-group>
                </el-submenu>
                <!--<el-submenu index="16" v-if="leftzd">-->
                <!--    <template slot="title">-->
                <!--    <i class="iconfont icon-zhandian-selected"></i>-->
                <!--    <span>站点管理</span>-->
                <!--    </template>-->
                <!--        <el-menu-item-group>-->
                <!--            <el-menu-item index="/sites" v-if="test('站点管理')">站点列表</el-menu-item>-->
                <!--        </el-menu-item-group>-->
                <!--</el-submenu>-->
                <el-submenu index="17" v-if="leftjk">
                    <template slot="title">
                    <i class="iconfont icon-shexiangtou"></i>
                    <span>监控管理</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/dinners" v-if="test('办宴点管理')">办宴点列表</el-menu-item>
                        <el-menu-item index="/camera" v-if="test('摄像头管理')">摄像头管理</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <el-submenu index="9" v-if="leftpx">
                    <template slot="title">
                    <i class="iconfont icon-peixunkaoshi"></i>
                    <span>培训考试</span>
                    </template>
                        <el-menu-item-group>
                            <el-menu-item index="/know" v-if="test('知识管理')">知识管理</el-menu-item>
                            <el-menu-item index="/footage" v-if="test('视频管理')">视频管理</el-menu-item>
                            <el-menu-item index="/banner" v-if="test('培训banner管理')">banner管理</el-menu-item>
                            <el-menu-item index="/question" v-if="test('题库管理')">题库管理</el-menu-item>
                            <el-menu-item index="/answer" v-if="test('答题管理')">答题管理</el-menu-item>
                        </el-menu-item-group>
                </el-submenu>
                <!--<el-submenu index="10" v-if="leftsc">-->
                <!--    <template slot="title">-->
                <!--    <i class="iconfont icon-yonghu"></i>-->
                <!--    <span>商城用户</span>-->
                <!--    </template>-->
                <!--        <el-menu-item-group>-->
                <!--            <el-menu-item index="/userlist" v-if="test('商城用户管理')">用户列表</el-menu-item>-->
                <!--            <el-menu-item index="/location" v-if="test('地址管理')">地址管理</el-menu-item>-->
                <!--            <el-menu-item index="/integral" v-if="test('积分活动')">积分活动</el-menu-item>-->
                <!--        </el-menu-item-group>-->
                <!--</el-submenu>-->
                <!--<el-submenu index="11" v-if="leftyh">-->
                <!--    <template slot="title">-->
                <!--    <i class="iconfont icon-youhuiquan"></i>-->
                <!--    <span>优惠券管理</span>-->
                <!--    </template>-->
                <!--        <el-menu-item-group>-->
                <!--            <el-menu-item index="/coupons" v-if="test('优惠券管理')">优惠券管理</el-menu-item>-->
                <!--        </el-menu-item-group>-->
                <!--</el-submenu>-->
                <!--<el-submenu index="12" v-if="leftdd">-->
                <!--    <template slot="title">-->
                <!--    <i class="iconfont icon-dingdan"></i>-->
                <!--    <span>订单管理</span>-->
                <!--    </template>-->
                <!--        <el-menu-item-group>-->
                <!--            <el-menu-item index="/indents" v-if="test('订单管理')">订单列表</el-menu-item>-->
                <!--        </el-menu-item-group>-->
                <!--</el-submenu>-->
                <!--<el-submenu index="13" v-if="leftsp">-->
                <!--    <template slot="title">-->
                <!--    <i class="iconfont icon-goods"></i>-->
                <!--    <span>商品管理</span>-->
                <!--    </template>-->
                <!--        <el-menu-item-group>-->
                <!--            <el-menu-item index="/articles" v-if="test('商品列表管理')">商品列表</el-menu-item>-->
                <!--            <el-menu-item index="/classify" v-if="test('商品分类管理')">商品分类</el-menu-item>-->
                <!--            <el-menu-item index="/events" v-if="test('活动管理')">活动管理</el-menu-item>-->
                <!--            <el-menu-item index="/shopban" v-if="test('商城banner管理')">banner管理</el-menu-item>-->
                <!--            <el-menu-item index="/recommend" v-if="test('推荐管理')">商品推荐管理</el-menu-item>-->
                <!--            <el-menu-item index="/evaluate" v-if="test('评价管理')">商品评价管理</el-menu-item>-->
                <!--            <el-menu-item index="/keyword" v-if="test('关键字管理')">关键词管理</el-menu-item>-->
                <!--        </el-menu-item-group>-->
                <!--</el-submenu>-->
                <!--<el-submenu index="14" v-if="leftys">-->
                <!--    <template slot="title">-->
                <!--    <i class="iconfont icon-yunshu"></i>-->
                <!--    <span>运输溯源</span>-->
                <!--    </template>-->
                <!--        <el-menu-item-group>-->
                <!--            <el-menu-item index="/vehicle" v-if="test('车辆管理')">车辆管理</el-menu-item>-->
                <!--            <el-menu-item index="/driver" v-if="test('司机管理')">司机管理</el-menu-item>-->
                <!--            <el-menu-item index="/transport" v-if="test('运输管理')">运输管理</el-menu-item>-->
                <!--        </el-menu-item-group>-->
                <!--</el-submenu>-->
                <!--<el-submenu index="15" v-if="leftcg">-->
                <!--    <template slot="title">-->
                <!--    <i class="iconfont icon-caigou"></i>-->
                <!--    <span>采购溯源</span>-->
                <!--    </template>-->
                <!--        <el-menu-item-group>-->
                <!--            <el-menu-item index="/buyer" v-if="test('采购员管理')">采购员管理</el-menu-item>-->
                <!--            <el-menu-item index="/supplier" v-if="test('供应商管理')">供应商管理</el-menu-item>-->
                <!--            <el-menu-item index="/ingredient" v-if="test('食材管理')">食材管理</el-menu-item>-->
                <!--        </el-menu-item-group>-->
                <!--</el-submenu>-->
            </el-menu>
        <!-- </el-col> -->
    </div>
</template>
<script>
import Bus from "../api/Bus";
export default {
    name:'Navigation',
    data(){
        return {
            logininfo: {
                userdata:{},
                nav:'',
                current:'',
            },
            leftone:[],  //左侧一级
            statistics:false,
            role:false,
            inter:false,
            jurisdiction:false,
            activeIndex: this.$route.path,
            isCollapse: false,
            show:true,
            // 二期
            leftcg:false,
            leftys:false,
            leftsp:false,
            leftdd:false,
            leftyh:false,
            leftsc:false,
            leftpx:false,
            leftjk:false,
            leftzd:false,
        }
    },
    watch: {
        '$route' (to, from) {
            // 监听路由的变化  如果路由发生改变则当前tab栏默认值也相应改变
            this.activeIndex = to.path
        }
    },
    created(){
        let userdata = JSON.parse(sessionStorage.getItem('userdata'))
        this.$set(this,'userdata',userdata)
        this.$axios.post(`/api-r/permission/getSysPermission/${userdata.id}`,{},{headers:{accessToken:userdata.token}})
        .then((res)=>{
            let btn = []
            res.data.permissionList.permissionList.forEach(x=>{
                btn.push(x.permissionCode)
            })
            sessionStorage.setItem('btn',JSON.stringify(btn))
            let navlist = []
            res.data.permissionList.menuList.forEach(x=>{
                navlist.push(x.menuName)
            })
            this.leftone = navlist
            if(navlist.indexOf('办宴统计')==-1&&navlist.indexOf('乡厨统计')==-1&&navlist.indexOf('周报表')==-1&&navlist.indexOf('日报表')==-1&&navlist.indexOf('报备统计')==-1&&navlist.indexOf('管理员')==-1){
                this.statistics = false
            }else{
                this.statistics = true
            }
            if(navlist.indexOf('乡厨管理')==-1&&navlist.indexOf('食安办管理')==-1&&navlist.indexOf('协管员管理')==-1&&navlist.indexOf('帮厨管理')==-1){
                this.role = false
            }else{
                this.role = true
            }
            if(navlist.indexOf('基础信息')==-1&&navlist.indexOf('协议管理')==-1){
                this.inter = false
            }else{
                this.inter = true
            }
            if(navlist.indexOf('管理员列表')==-1&&navlist.indexOf('权限管理')==-1&&navlist.indexOf('短信管理')==-1){
                this.jurisdiction = false
            }else{
                this.jurisdiction = true
            }
            // 二期
            if(navlist.indexOf('站点管理')==-1){
                this.leftzd = false
            }else{
                this.leftzd = true
            }
            if(navlist.indexOf('办宴点管理')==-1&&navlist.indexOf('摄像头管理')==-1){
                this.leftjk = false
            }else{
                this.leftjk = true
            }
            if(navlist.indexOf('知识管理')==-1&&navlist.indexOf('视频管理')==-1&&navlist.indexOf('培训banner管理')==-1&&navlist.indexOf('题库管理')==-1&&navlist.indexOf('答题管理')==-1){
                this.leftpx = false
            }else{
                this.leftpx = true
            }
            if(navlist.indexOf('商城用户管理')==-1&&navlist.indexOf('地址管理')==-1&&navlist.indexOf('积分活动')==-1){
                this.leftsc = false
            }else{
                this.leftsc = true
            }
            if(navlist.indexOf('优惠券管理')==-1){
                this.leftyh = false
            }else{
                this.leftyh = true
            }
            if(navlist.indexOf('订单管理')==-1){
                this.leftdd = false
            }else{
                this.leftdd = true
            }
            if(navlist.indexOf('商品列表管理')==-1&&navlist.indexOf('商品分类管理')==-1&&navlist.indexOf('活动管理')==-1&&navlist.indexOf('商城banner管理')==-1&&navlist.indexOf('推荐管理')==-1
            &&navlist.indexOf('评价管理')==-1&&navlist.indexOf('关键字管理')==-1){
                this.leftsp = false
            }else{
                this.leftsp = true
            }
            if(navlist.indexOf('车辆管理')==-1&&navlist.indexOf('司机管理')==-1&&navlist.indexOf('运输管理')==-1){
                this.leftys = false
            }else{
                this.leftys = true
            }
            if(navlist.indexOf('采购员管理')==-1&&navlist.indexOf('供应商管理')==-1&&navlist.indexOf('食材管理')==-1){
                this.leftcg = false
            }else{
                this.leftcg = true
            }
            // let _data = this.$router.options.routes
            // this.leftone = _data[1].children

            // console.log(navlist)
            // console.log(this.leftone)

            // let ceshi = []
            // for (var s in navlist) {
            //     for(var i=0;i<this.leftone.length;i++){
            //         if(navlist[s]==this.leftone[i].meta.title){
            //             ceshi.push(this.leftone[i])
            //         }
            //     }
            // }
            // console.log(this.$route.matched)   //获取当前的所在路由
            // let arr1 = ''
            // for(let i of _data){
            //     if(i.name == this.$route.matched[0].name){
            //         // this.touterData = i    //获取此路由中的二级菜单
            //         arr1 = i
            //     }
            // }
            // console.log(arr1)
            // var arr2 = []
            // arr1.children.forEach(x=>{
            //     for(var i=0;i<navlist.length;i++){
            //         if(x.meta.title == navlist[i]){
            //             arr2.push(x)
            //         }
            //     }
            // })
            // console.log(arr2)
            // this.current = [this.$route.matched[1].name]
            // this.$forceUpdate()
            // sessionStorage.setItem('nav',JSON.stringify(pin))
        })
    },
    methods:{
        handleSelect (key, keyPath) {
            this.activeIndex = key
        },
        nav(){
            if(this.isCollapse){
                this.isCollapse = false
            }else if(!this.isCollapse){
                this.isCollapse = true
            }
            this.$emit('unfold',this.isCollapse);
            Bus.$emit("unfold",this.isCollapse);
        },
        test(i){
            if(this.leftone.indexOf(i) == -1){
                return false
            }else{
                return true
            }
        },
        translateDataToTree(data) {
            let parents = data.filter(value => value.parentId == 'undefined' || value.parentId == 0)
            let childrens = data.filter(value => value.parentId !== 'undefined' && value.parentId != 0)
            let translator = (parents, childrens) => {
                parents.forEach((parent) => {
                    childrens.forEach((current, index) => {
                        if (current.parentId === parent.id) {
                            let temp = JSON.parse(JSON.stringify(childrens))
                            temp.splice(index, 1)
                            translator([current], temp)
                            typeof parent.children !== 'undefined' ? parent.children.push(current) : parent.children = [current]
                        }
                    })
                }
                )
            }
            translator(parents, childrens)
            return parents
        }
    },
    mounted(){
        let userdata = JSON.parse(sessionStorage.getItem('userdata'))
        // 当前角色所在地区
        if(localStorage.getItem('region')==null){
            let data = this.$qs.stringify({
                adminAreasId:userdata.areasId,
            })
            this.$axios.post(`/api-r/area/getAreaListInfo`,data,{headers:{accessToken:userdata.token}})
            .then(res=>{
                let address = res.data.areaListInfoList
                // let options = this.translateDataToTree(address)
                let region = JSON.stringify(address)
                localStorage.setItem('region',region)
            })
        }
    }
}
</script>
<style lang="scss">
    .el-col-12{
        width: 100%
    }
    .el-menu{
        border:none
    }
    .el-submenu .el-menu-item{
        min-width: 180px;
    }
    .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 200px;
        min-height: 400px;
    }
    .unfold{
        width: 100%;
        background: #e7f6f3;
        line-height: 46px;
        text-align: center;
        color: #11A983;
        margin: 10px 0;
        cursor: pointer;
    }
    .el-menu-item-group>ul>a{
        text-decoration: none
    }
    .main-menu {
      .el-menu-item.is-active{
        background-color: #11A983 !important;
        color: #ffffff;
        font-weight: bold;
      }
    }
</style>
